import { render, staticRenderFns } from "./pinterest-icon.vue?vue&type=template&id=c676143c"
import script from "./pinterest-icon.vue?vue&type=script&lang=js"
export * from "./pinterest-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports